import type { SVGProps } from 'react';
const SvgDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M25.3031 8.16544L20.2578 3.39237C19.7212 2.88467 19.0188 2.6051 18.2801 2.6051H8.67468C7.08786 2.6051 5.79688 3.89609 5.79688 5.48291V26.517C5.79688 28.1039 7.08786 29.3948 8.67468 29.3948H23.3253C24.9121 29.3948 26.2031 28.1039 26.2031 26.517V10.256C26.2031 9.46856 25.8751 8.70657 25.3031 8.16544ZM23.7785 8.88395H19.872C19.7277 8.88395 19.6103 8.76659 19.6103 8.62233V4.94062L23.7785 8.88395ZM23.3253 27.8251H8.67468C7.9534 27.8251 7.36659 27.2383 7.36659 26.517V5.48291C7.36659 4.76162 7.9534 4.17481 8.67468 4.17481H18.0406V8.62233C18.0406 9.63213 18.8622 10.4537 19.872 10.4537H24.6334V26.517C24.6334 27.2383 24.0466 27.8251 23.3253 27.8251Z"
      fill="currentColor"
    />
    <path
      d="M21.598 13.0699H10.0867C9.65329 13.0699 9.30188 13.4214 9.30188 13.8548C9.30188 14.2883 9.65329 14.6397 10.0867 14.6397H21.598C22.0314 14.6397 22.3828 14.2883 22.3828 13.8548C22.3828 13.4214 22.0314 13.0699 21.598 13.0699Z"
      fill="currentColor"
    />
    <path
      d="M21.598 17.2577H10.0867C9.65329 17.2577 9.30188 17.6091 9.30188 18.0425C9.30188 18.476 9.65329 18.8274 10.0867 18.8274H21.598C22.0314 18.8274 22.3828 18.476 22.3828 18.0425C22.3828 17.6091 22.0314 17.2577 21.598 17.2577Z"
      fill="currentColor"
    />
    <path
      d="M13.8917 21.4409H10.0867C9.65329 21.4409 9.30188 21.7923 9.30188 22.2258C9.30188 22.6592 9.65329 23.0106 10.0867 23.0106H13.8917C14.3252 23.0106 14.6766 22.6592 14.6766 22.2258C14.6766 21.7923 14.3252 21.4409 13.8917 21.4409Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgDocument;
